import React, { useState, useRef } from 'react';
import { usePdf } from '@mikecousins/react-pdf';
import { Button } from 'reactstrap';
import { ChevronRight, ChevronLeft, ZoomIn, ZoomOut} from '@material-ui/icons';
import ExpandIcon from '../../../../../assets/images/module/general/ExpandIcon.svg';
import { Stack } from '@mantine/core';
import { useEffect } from 'react';
import UtilityBillingTemplate from '../../../../../views/pages/Module/UtilityBilling/UtilityBillingTemplate3';

const MOBILE_SIZE = 992;
const SMALLER_MOBILE_SIZE = 500;
const PreviewMessagePdfHeatingInformation = ({selectedBillingStatement, selectedRecipient, compositionOfHeatingCostsSwitch, costSplitWarmWaterAndHeatingSwitch, splitBaseConsumptionCostsSwitch, heatingFilter}) => {

    console.log('selectedBillingStatement_12: ', selectedBillingStatement);
  return (
    <div style={{width: '210mm', height: '297mm', background: 'white', //boxShadow: '0px 1px 2px #000', 
    padding: '12mm 12mm 20mm 14mm'}}>
      {/* <div style={{marginTop: '20mm', fontSize: '9pt', fontFamily: 'Arial', textAlign: 'justify'}} dangerouslySetInnerHTML={{__html: newMessageBody}}/> */}
      {selectedBillingStatement && <UtilityBillingTemplate messagePreview={true} billingStatmentId={selectedBillingStatement.id} tenantId={selectedRecipient.tenantId} divName={'divToPrint2'} compositionOfHeatingCostsSwitch={compositionOfHeatingCostsSwitch} costSplitWarmWaterAndHeatingSwitch={costSplitWarmWaterAndHeatingSwitch} splitBaseConsumptionCostsSwitch={splitBaseConsumptionCostsSwitch} heatingFilter={heatingFilter}/>}
    </div>
  );
};

export default PreviewMessagePdfHeatingInformation;